module.exports = __webpack_public_path__ + "img/09_bg.3530793e.png";